import type { FC } from "react";
import React from "react";

import { createDisplayNameForAvaPictureElement } from "../../utils/getDisplayName";
import { createTestIdForAvaPictureElement } from "../../utils/getTestId";

import classes from "./AvaPictureGift.styl";

export type AvaPictureGiftSize = number | `${number}`;

interface IAvaPictureGiftProps {
    /** URL изображения подарка */
    src: string;
    /** Alt-атрибут изображения подарка */
    alt: string;
    /** Ширина изображения подарка */
    width?: AvaPictureGiftSize;
    /** Высота изображения подарка */
    height?: AvaPictureGiftSize;
}

const AVA_PICTURE_GIFT_TEST_ID = createTestIdForAvaPictureElement("Gift");

export const AvaPictureGift: FC<IAvaPictureGiftProps> = ({
    src,
    alt,
    width,
    height,
}) => {
    return (
        <img
            src={src}
            alt={alt}
            width={width}
            height={height}
            className={classes["gift"]}
            data-tsid={AVA_PICTURE_GIFT_TEST_ID}
        />
    );
};

AvaPictureGift.displayName = createDisplayNameForAvaPictureElement("Gift");

export default AvaPictureGift;
